<div class="modal-header">
  <p class="modal-title">Infografia VJNF</p>
  <button type="button" class="text-white close" data-dismiss="modal" aria-hidden="true" (click)="clear()">&times;</button>
</div>
<div class="mb--7 modal-body mx--5 p-0">
  <iframe
    width="800"
    height="600"
    src="https://www.youtube-nocookie.com/embed/I8Qw9iTkcQQ?rel=0&amp;controls=0&amp;showinfo=0;autoplay=1"
    allow="autoplay; encrypted-media"
    allowfullscreen
  ></iframe>
</div>
